module.exports = __webpack_public_path__ + "PERUVIANserve-4.b19c9eac.png";